import React, { useId, useState } from "react";
import { DisclosureContext } from "./disclosure-context.js";

/* DisclosureRoot — the open state of one disclosure, and nothing else.

   It renders no element of its own, so a DisclosureTrigger and its
   DisclosurePanel can sit anywhere under it — in two different rows, a toolbar
   and a body — and still carry one aria-expanded / aria-controls pair. */

export interface DisclosureRootProps {
  /** Controlled state; omit for an uncontrolled disclosure. */
  open?: boolean | undefined;
  defaultOpen?: boolean | undefined;
  onOpenChange?: ((open: boolean) => void) | undefined;
  children: React.ReactNode;
}

export function DisclosureRoot({
  open: controlledOpen,
  defaultOpen = false,
  onOpenChange,
  children,
}: DisclosureRootProps) {
  const panelId = useId();
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const open = controlledOpen ?? uncontrolledOpen;

  const toggle = (): void => {
    if (controlledOpen === undefined) setUncontrolledOpen(!open);
    onOpenChange?.(!open);
  };

  return (
    <DisclosureContext.Provider value={{ open, panelId, toggle }}>
      {children}
    </DisclosureContext.Provider>
  );
}
